import React, { useContext } from 'react';
import classnames from 'classnames';
import MachineTranslationButton from '@fiverr-private/machine_translation/src/components/MachineTranslationButton';
import { TOTAL_RESULTS_TRANSLATE_BUTTON_SEPERATOR } from '../../../utils/constants';
import { TRANSLATION_CONTEXT } from '../../../config/ugcTranslations';
import { AppContext } from '../../context/listingsContext';

import './index.scss';

const getMTButtonStyle = (abTestsProps, isBusiness, isTouch, isToggled) => {
    let style = isTouch ? MachineTranslationButton.STYLES.DEFAULT : MachineTranslationButton.STYLES.LEAN_TOGGLED;

    if (isBusiness) { return style; }

    const { inPromoteMTCtaExpBGroup, inPromoteMTCtaExpCGroup } = abTestsProps;

    if (inPromoteMTCtaExpBGroup) {
        style = MachineTranslationButton.STYLES.WITH_EDUCATION;
    }

    if (inPromoteMTCtaExpCGroup) {
        style = isToggled ? MachineTranslationButton.STYLES.LEAN_TOGGLED : MachineTranslationButton.STYLES.DEFAULT;
    }

    return style;
};

const MachineTranslationButtonWrapper = ({ gigsListings, showSeparator }) => {
    const appContext = useContext(AppContext);

    const {
        isTouch,
        showTranslatedUGC,
        loading,
        onTranslateBtnClick,
        sourceInfo,
        listings: [listings],
        isBusiness } = appContext;

    const { context: { abTestsProps } } = listings;

    const { inPromoteMTCtaExpBGroup, inPromoteMTCtaExpCGroup } = abTestsProps;

    const classes = classnames('machine-translation-button-wrapper', {
        'layout-row is-touch': isTouch,
        'show-separator': showSeparator,
        'mobile-centered': inPromoteMTCtaExpBGroup,
        'promote-mt-exp-c-group': inPromoteMTCtaExpCGroup
    });
    const hidePrefix = isTouch;
    const gigListingsSourceInfo = { ...sourceInfo, context: TRANSLATION_CONTEXT.GENERAL };
    const gigListingsAppContext = { ...appContext, sourceInfo: gigListingsSourceInfo };

    return (
        <>
            {showSeparator && TOTAL_RESULTS_TRANSLATE_BUTTON_SEPERATOR}
            <div className={classes}>
                <MachineTranslationButton loading={loading}
                    toggled={showTranslatedUGC}
                    style={getMTButtonStyle(abTestsProps, isBusiness, isTouch, showTranslatedUGC)}
                    sourceInfo={gigListingsSourceInfo}
                    onClick={async() => await onTranslateBtnClick(gigsListings, gigListingsAppContext, hidePrefix)}/>
            </div>
        </>
    );
};

export default MachineTranslationButtonWrapper;
